webpackJsonp([4010140034000],{

/***/ 1213:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0012_wither.jpg","type":"Minor Spell","subtype":"Debuff","cost":2,"ATK":null,"HP":null,"rules_text_1":"Put a -1/-1 rune on a unit or hero.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Wither","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Neutral","spec":null,"bottom":"Magic","rulings":[{"ruling":"If you put the -1/-1 rune on an X/1 unit, that will unit will die (because it has 0 HP) even if it had armor.","date":"2016-03-04T08:00:00.000Z","author":"Sirlin"}],"keywords":[],"slug":"wither"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"wither","keywords":[],"imageRegex":"/wither.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-wither-5ddaae4be07b344efd45.js